import { useContext } from 'react';
import type { TenantConfig } from '../types/tenant';
import { TenantConfigContext, type TenantStatus } from './tenant-context';

export function useTenantStatus(): TenantStatus {
  const ctx = useContext(TenantConfigContext);
  if (!ctx) throw new Error('useTenantStatus must be used inside <TenantConfigProvider>');
  return ctx.status;
}

export function useTenantConfig(): TenantConfig {
  const status = useTenantStatus();
  if (status.kind !== 'ready') {
    throw new Error('useTenantConfig called before tenant is ready — gate on useTenantStatus first');
  }
  return status.config;
}

export function useSwitchTenant(): (id: string) => void {
  const ctx = useContext(TenantConfigContext);
  if (!ctx) throw new Error('useSwitchTenant must be used inside <TenantConfigProvider>');
  return ctx.switchTenant;
}
